// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__21--F","requiredAsterisk":"Info_requiredAsterisk__1FO5R"};